import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import KaerComponent, { isEdit } from '@kaer/kaer-component';
import init from './init';
import '@/styles/main.scss';
import '@/utils/flexable';
import { initAdapter, getAdapter, env, ZYToast } from '@zyf2e/adapt';
import '@zyf2e/capui-mobile/lib/index.css';
import { Sticky, Popup, Toast, Dialog, Col, Row, Divider, List, Empty, Loading } from '@zyf2e/capui-mobile';
import { apiUrl, staticUrl } from '@/config';
import Components from './components';
import { px2rem, getRouteQuery, getUrlParam } from './utils/utils';
import { uploadData } from '@/utils/uploadData';
import { fetchTelescopeCode } from './api';

Vue.config.productionTip = false;
Vue.directive('track-event', window.Telescope.vTrackEvent);
Vue.directive('track-view', window.Telescope.vTrackView);
Vue.directive('track-page', window.Telescope.vTrackPage);
Vue.use(KaerComponent, init(Vue));
Vue.use(Components);
Vue.use(Sticky)
  .use(Popup)
  .use(Dialog)
  .use(Col)
  .use(Row)
  .use(Divider)
  .use(Toast)
  .use(List)
  .use(Loading)
  .use(Empty);

async function main() {
  const activityId = window.__kaer_config__?.page?.props?.activityId;
  let options = {
    baseURL: apiUrl,
    jumpWechatMPLogin: true,
    loginTelescopeParams: {
      activityId: activityId || undefined,
      channel: getUrlParam('channel') || undefined
    }
  };

  let timer = null;

  // 解决安卓app内，未登录进入webview时，登录成功的回调 location.reload 不刷新页面的问题
  if (env.inAPP && env.inAndroid) {
    options.customAppLoginSuccessCb = () => {
      // 微信登页未完全关闭，导致 Sailer.replace 替换了原生页，故延迟
      timer = setTimeout(() => {
        Sailer.replace(window.location.href);
        timer = null;
      }, 800);
    };
  }

  if (!window.location.host.includes('.91jkys.com') && (env.inWechat || env.inH5)) {
    const query = getRouteQuery();
    const token = query.user_token; // 从url 取token
    let uid = '';
    try {
      // 小程序里uid从telescope-info获取
      uid = JSON.parse(query['telescope-info']).uid || query.user_id;
    } catch (error) {
      uid = query.user_id;
    }

    // 判断token是否有值
    if (token) {
      // 设置storage
      localStorage.setItem('user_token', token);
      document.cookie = `login=true; domain=${document.domain};`;
      document.cookie = `user_id=${uid}; domain=${document.domain};`;
      Telescope.login({ uid });

      if (!env.inWechatMiniProgram) {
        let replaceUrl = location.origin + location.pathname + '#/';
        Object.keys(query).forEach(key => {
          const value = query[key];
          if (!['user_token', 'user_id'].includes(key)) replaceUrl += `${replaceUrl.includes('?') ? '&' : '?'}${key}=${value}`;
        });
        location.replace(replaceUrl);
      }
    }

    options = {
      ...options,
      customHeaders: {
        token: localStorage.getItem('user_token') || undefined
      },
      customWebPageLoginUrl: `${staticUrl}collection/login-transfer-page/dist/index.html?redirectUrl=${encodeURIComponent(
        location.href
      )}&loginTelescopeParams=${encodeURIComponent(JSON.stringify(options.loginTelescopeParams))}`
    };
  }

  await initAdapter(options);
  const adapt = getAdapter();

  let teleCodes = {};
  if (!isEdit) {
    try {
      teleCodes = await fetchTelescopeCode();
    } catch (err) {
      console.error(err);
    }
  }
  Vue.prototype.adapt = adapt;
  Vue.prototype.env = env;
  Vue.prototype.ZYToast = ZYToast;
  Vue.prototype.px2rem = px2rem;
  Vue.prototype.uploadData = uploadData;
  Vue.prototype.$teleCodes = teleCodes;
  Vue.prototype.$bus = new Vue();
  Vue.prototype.$loginTimer = timer;
  Vue.prototype.$goBack = () => {
    if (env.inWechatMiniProgram) {
      wx.miniProgram.navigateBack();
    } else {
      adapt.goBack();
    }
  };

  window.__kaer_adapt__ = adapt;
  window.__kaer_uploadData__ = uploadData;

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

main();
